module.exports = __webpack_public_path__ + "static/media/3.145ba7bf.png";